export const COLORS = {
  white: "#FFFFFF",
  navy: "#1F2428",
  transparentNavy1: "#1F242880",
  transparentNavy2: "#323A45EB",
  highlightedBlue: "#0086C5",
  green: "#3A4C01",
  black: "#333333",
  gray: "#FFFFFFB3",
  transparentGray: "#00000080",
};

export default COLORS;
